import styled from 'styled-components';

export const SelectBox = styled.div<{ spacing: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: left;
  padding: 5px;
  width: 100%;
  margin-right: ${(props) => props.spacing};

  &:hover {
    cursor: pointer !important;
  }
`;

export const BodyText = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.palette.text.secondary};
  padding-right: 10px;
  p {
    font-size: 14px;
    margin: 0;
  }
`;

export const RadioButtonStyle = styled.div`
  margin-right: 10px;
`;

export const InputStyle = styled.div`
  input[type='radio'] {
    margin: 0;
    opacity: 0;
  }

  &:focus-within {
    border-radius: 5px;
    box-shadow: ${({ theme }) => theme.shadows[1]};
  }
`;
